<template>
  <div>
    <v-dialog v-model="open" persistent>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-btn style="float: right" class="mt-2 mr-2" icon @click="fechar()"
            ><v-icon>mdi-close</v-icon></v-btn
          >

          <v-card-title class="headline">{{ t("Agendamentos") }} </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="event.nome"
                  :label="t(`nome`)"
                  required
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  auto-grow
                  rows="1"
                  v-model="event.descricao"
                  :label="t(`descricao`)"
                  required
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  class="mt-4"
                  v-model="event.numero"
                  :label="t(`numero`)"
                  required
                  :rules="[(v) => !!v || 'Campo obrigatório']"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          required
                          v-model="dateFormatted"
                          :label="t(`data`)"
                          hint="DD/MM/YYYY"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          @blur="date = parseDate(dateFormatted)"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :locale="locale"
                        v-model="date"
                        year-format
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-menu
                      ref="menu"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="event.hora"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="event.hora"
                          :label="t('selecioneohorario')"
                          prepend-icon="mdi-clock-time-four-outline"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="menu2"
                        format="24hr"
                        v-model="event.hora"
                        full-width
                        @click:minute="$refs.menu.save(event.hora)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-btn
                  color="primary"
                  text
                  style="float: right"
                  v-if="!editar"
                  @click="salvar()"
                  >Adicionar</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  style="float: right"
                  v-else
                  @click="salvar()"
                  >Salvar</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="events && events.length > 0">
                <v-alert
                  v-for="(evento, index) in events"
                  :key="evento.nome"
                  color="cyan"
                  border="left"
                  elevation="2"
                  colored-border
                >
                  <v-row align="center">
                    <v-col class="grow">
                      <h4>{{ evento.nome }}</h4>
                      {{ evento.descricao }}
                    </v-col>
                    <v-col class="shrink">
                      <v-btn
                        icon
                        @click="
                          event = evento;
                          editar = true;
                        "
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col class="shrink">
                      <v-btn
                        icon
                        @click="
                          events.splice(index, 1);
                          salvar();
                        "
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-alert>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar v-model="snackbar" color="error" bottom>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar = false">{{
          t("ok")
        }}</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
   
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import uid from "uid";
export default {
  name: "Transferencia",
  props: {
    open: { type: Boolean, default: false },
    call: { type: Object, default: null },
  },
  data() {
    return {
      instancia: null,
      menu1: false,
      menu2: false,
      valid: false,
      event: {
        nome: null,
        data: null,
        descricao: null,
        numero: null,
        hora: null,
      },
      filas: [],
      filasAgente: [],
      snackbar: false,
      snackbarText: null,
      editar: false,
      events: JSON.parse(localStorage.getItem(`events`)),
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
    };
  },
  watch: {
    open(nw) {
      if (nw) {
        this.event = {};
        this.event.data = this.formatDate(this.date);
        this.events = JSON.parse(localStorage.getItem(`events`));
        if (this.call) {
          this.event.nome = this.call.nome;
          this.event.numero = this.call.numero;
          for (let key in this.call.dados) {
            if (!this.event.descricao) {
              this.event.descricao = key + ":" + this.call.dados[key] + "\r\n";
            } else {
              this.event.descricao += key + ":" + this.call.dados[key] + "\r\n";
            }
          }
        }
        // this.newWhats();
      }
    },
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
      this.event.data = this.formatDate(this.date);
    },
  },
  created() {
    this.event.data = this.formatDate(this.date);
    // if(this.token) this.$router.push("/main");
  },
  computed: {
    ...mapState("xc", {
      cliente: (state) => state.cliente,
      agentes: (state) => state.agentes,
      atendimento: (state) => state.atendimento,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
    }),
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    locale() {
      let config = JSON.parse(localStorage.getItem(`config`));
      return config.idioma.split(`_`)[0];
    },
  },

  methods: {
    ...mapActions("xc", [
      "getDefault",
      "updateCliente",
      "transfereAtendimento",
      "setTransferenciaModal",
      "newWhatsApp",
    ]),
    fechar() {
      this.$emit("update", false);
    },
    salvar() {
      if (!this.$refs.form.validate()) return;
      if (!this.events) this.events = [];
      if (this.editar) {
        this.editar = false;
      } else {
        this.event.id = uid();
        this.events.push(this.event);
      }
      localStorage.setItem("events", JSON.stringify(this.events));
      this.event = {};
      this.$emit("update", false);
    },
    novoEvento() {
      this.$emit("update", "new");
      // this.newWhatsApp(data);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>
<style>
</style>